// Angular catches all the exceptions (swallows them!) and just logs them inside console
// https://stackoverflow.com/questions/45827840/application-insights-does-not-track-unhandled-browser-exceptions-in-angular-app

import { ErrorHandler, Injectable, inject } from '@angular/core';

import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  readonly #applicationInsightsService = inject(ApplicationInsightsService);

  handleError(error: Error): void {
    console.error(error);
    this.#applicationInsightsService.logException(error);
  }
}
